export default {
  cpp: 'f2a10331-fb53-4a0a-a436-7a2cdb532190',
  default: 'creditmatcher',
};
